export default {
    // header
    headerImg: 'http://music.chinaman.cn/mybigdatas/ids/static/logo001.png',
    navList: [{
        text: "主页",
        url: "/",
    },
    {
        text: "承办方",
        url: "/organizing",
    },
    {
        text: "委员会",
        url: "/committee",
    },
    {
        text: "主题报告",
        url: "/session",
    },
    {
        text: "议程",
        url: "/program",
    },
    {
        text: "提交稿件",
        url: "/submissions",
    },
    {
        text: "会议注册",
        url: "/reg",
    },
    {
        text: "参会者须知",
        url: "sb",
        children: [{
            text: "签证",
            url: "/visa",
        },
        {
            text: "会场",
            url: "/travel",
        },
        {
            text: "旅行",
            url: "/traveltwo",
        },
        {
            text: "酒店",
            url: "/hotel",
        },
        ],
    },
    {
        text: "赞助商",
        url: "/sponsors",
    },
    {
        text: "奖项",
        url: "/awards",
    },
    ],
    // header
    // index
    indexTitle1: '会议信息',
    indexText1: `干燥是许多工业生产中的重要工艺过程之一。近年来，干燥技术正朝着高效、环保、智能的方向发展。自加拿大麦吉尔大学Arun S. Mujumdar教授于1978年发起每两年一届的国际干燥大会 (International Drying Symposia, IDS) 以来，IDS会议已成为全球干燥科学与技术领域中水平最高、规模最大的学术盛会，帮助和提高了全球范围内学术界和工业界科研技术人员对干燥科学和技术的深入了解。 <p>由江南大学承办的第23届国际干燥大会（IDS 2024）将于2024年11月22-25日在中国无锡君来世尊酒店举行。IDS2024将延续IDS系列会议的传统，成为传播和交流与干燥/脱水科学和技术的研究、发展和应用相关的最前沿、最全面的研究成果和信息的全球论坛。来自世界各地学术界和工业界的顶尖科学家和工程师将齐聚一堂。会议期间的颁奖活动也将是世界干燥界这一重要学术活动的一部分。</p>   <p> 热烈欢迎您参加这一干燥科学与技术领域最重要的全球盛会。我们期待着在2024年11月22-25日的IDS 2024会议期间与所有与会者相聚在无锡这座美丽的城市！</p>`,
    indexTitle2: '重要日期',
    indexdateList: [{
        date: "2024年3月15日:",
        text: "摘要提交截止",
    },
    {
        date: "2024年3月31日:",
        text: "摘要录用通知",
    },
    {
        date: "2024年4月30日:",
        text: "稿件提交截止"
    },
    {
        date: "2024年6月15日:",
        text: "稿件录用通知",
    },
    {
        date: "2024年7月1日:",
        text: " “早鸟”注册报名截止",
    },
    {
        date: "2024年9月1日:",
        text: "注册报名截止"
    },
    ],
    indexTitle3: '相关新闻',
    indexText3: '第一轮会议通知',
    indexText4: '历届IDS大会',
    indexText5: [{
        title: "第1届IDS（IDS1978）: ",
        text: "加拿大 蒙特利尔"
    },
    {
        title: "第2届IDS（IDS1980）: ",
        text: "加拿大 蒙特利尔"
    },
    {
        title: "第3届IDS（IDS1982）: ",
        text: "英国 伯明翰"
    },
    {
        title: "第4届IDS（IDS1984）: ",
        text: "日本 京都"
    },
    {
        title: "第5届IDS（IDS1986）: ",
        text: "美国 剑桥"
    },
    {
        title: "第6届IDS（IDS1988）: ",
        text: "法国 凡尔赛"
    },
    {
        title: "第7届IDS（IDS1990）: ",
        text: "捷克斯洛伐克 布拉格"
    },
    {
        title: "第8届IDS（IDS1992）: ",
        text: "加拿大 蒙特利尔"
    },
    {
        title: "第9届IDS（IDS1994）: ",
        text: "澳大利亚 黄金海岸"
    },
    {
        title: "第10届IDS（IDS1996）: ",
        text: "波兰 克拉科夫"
    },
    {
        title: "第11届IDS（IDS1998）: ",
        text: "希腊 哈尔基迪基"
    },
    {
        title: "第12届IDS（IDS2000）: ",
        text: "荷兰 诺德韦克豪特",
    },
    {
        title: "第13届IDS（IDS2002）: ",
        text: "中国 北京"
    },
    {
        title: "第14届IDS（IDS2004）: ",
        text: "巴西 圣保罗"
    },

    {
        title: "第15届IDS（IDS2006）: ",
        text: "匈牙利 布达佩斯"
    },
    {
        title: "第16届IDS（IDS2008）: ",
        text: "印度 海得拉巴"
    },
    {
        title: "第17届IDS（IDS2010）: ",
        text: "德国 马格德堡"
    },
    {
        title: "第18届IDS（IDS2012）: ",
        text: "中国 厦门"
    },
    {
        title: "第19届IDS（IDS2014）: ",
        text: "法国 里昂"
    },
    {
        title: "第20届IDS（IDS2016）: ",
        text: "日本 岐阜"
    },
    {
        title: "第21届IDS（IDS2018）: ",
        text: "西班牙 瓦伦西亚"
    },
    {
        title: "第22届IDS（IDS2020/2022）: ",
        text: "美国 伍斯特"
    },
    {
        title: "第23届IDS（IDS2024）: ",
        text: "中国 无锡"
    },
    ],
    indexText6: "我的会议信息管理",
    indexText7: "邮件",
    indexText8: "密码",
    indexText9: "登录",
    indexText10: "创建账户",
    indexText11: "登录以进行:",
    indexText12: "摘要提交",
    indexText13: "全文稿件提交",
    indexText14: "在线注册",
    indexText15: "IDS 2024主题",
    indexText16: 'http://music.chinaman.cn/mybigdatas/ids/static/logo003.png',
    indexText17: "已确认的主题演讲嘉宾",
    indexText18: [
        [{
            num: "002",
            title: "Arun S. Mujumdar 教授",
            text: "麦吉尔大学",
            tip: "加拿大",
        },
        {
            num: "001",
            title: "Alex Martynenko 教授",
            text: "达尔豪斯大学",
            tip: "加拿大",
        },
        {
            num: "018",
            title: "Azharul Karim 教授",
            text: "昆士兰科技大学",
            tip: "澳大利亚",
        },
        {
            num: "007",
            title: "Benu Adhikari 教授",
            text: "皇家墨尔本理工大学",
            tip: "澳大利亚",
        },
        {
            num: "003",
            title: "Bhesh Bhandari 教授",
            text: "昆士兰大学",
            tip: "澳大利亚",
        },
        {
            num: "017",
            title: "Chinnaswamy Anandharamakrishna 博士",
            text: "CSIR-NIIST",
            tip: "印度",
        },
        ],
        [{
            num: "006",
            title: "Chung Lim Law 教授",
            text: "马来西亚诺丁汉大学",
            tip: "马来西亚",
        },
        {
            num: "012",
            title: "Duu-Jong Lee 教授",
            text: "香港城市大学",
            tip: "中国",
        },
        {
            num: "009",
            title: "Evangelos Tsotsas 教授",
            text: "马格德堡大学",
            tip: "德国",
        },
        {
            num: "022",
            title: "Gennadiy Semenov 教授",
            text: "俄罗斯生物技术大学",
            tip: "俄罗斯",
        },
        {
            num: "011",
            title: "Hongwei Xiao 教授",
            text: "中国农业大学",
            tip: "中国",
        },
        {
            num: "013",
            title: "Ireneusz Zbiciński 教授",
            text: "罗兹理工大学",
            tip: "波兰",
        },
        ],
        [{
            num: "015",
            title: "Itaya Yoshinori 教授",
            text: "岐阜大学",
            tip: "日本",
        }, {
            num: "021",
            title: "Jamal Yagoobi 教授",
            text: "伍斯特理工学院",
            tip: "美国",
        },
        {
            num: "014",
            title: "Patrick Perre 教授",
            text: "巴黎萨克雷大学",
            tip: "法国",
        },
        {
            num: "016",
            title: "Peng Xu 教授",
            text: "中国计量大学",
            tip: "中国",
        },
        {
            num: "004",
            title: "Sakamon Devahastin 教授",
            text: "国王科技大学",
            tip: "泰国",
        },
        {
            num: "023",
            title: "Shaojin Wang 教授",
            text: "西北农林科技大学",
            tip: "中国",
        },
        ],
        [{
            num: "024",
            title: "Sheyla Ramsay 博士",
            text: "百事公司",
            tip: "美国",
        },
        {
            num: "008",
            title: "Shusheng Pang 教授",
            text: "坎特伯雷大学",
            tip: "新西兰",
        }, {
            num: "010",
            title: "Song Miao 教授",
            text: "Teagasc国家食品研究中心",
            tip: "爱尔兰",
        }, {
            num: "019",
            title: "Vijaya Raghavan 教授",
            text: "麦吉尔大学",
            tip: "加拿大",
        },
        {
            num: "005",
            title: "Xiao Dong Chen 教授",
            text: "苏州大学",
            tip: "中国",
        },
        {
            num: "020",
            title: "Xu Duan 教授",
            text: "河南科技大学",
            tip: "中国",
        },
        ],
        [{
            num: '025',
            title: "Zhongli Pan 教授",
            text: "加利福尼亚大学戴维斯分校",
            tip: "美国"
        }]
    ],
    indexText19: "联系我们",
    indexText20: "地址：",
    indexText21: "中国无锡江南大学食品学院",
    indexText22: "电子邮件：",
    indexText23: "ids2024@jiangnan.edu.cn",
    indexText24: "网址：",
    indexText25: "www.ids2024.com",
    indexText26: "登录成功",
    indexText27: "",
    indexText28: "",
    indexText29: "",
    indexText30: "",

    indexmsgemail: "请输入你的邮箱",
    indexmsgpwd: "请输入你的密码",
    // index

    //footer 
    footReserved: '© IDS 2024 版权所有',
    footSymposium: 'IDS 2024 | 第23届国际干燥大会',
    footText1: "京ICP备20012029号-3",

    //organizing
    organizingTitle: '江南大学',
    organizingsmalltitle: '学校概况',
    organizingtext1: '江南大学坐落于美丽的太湖之滨-无锡，是教育部直属、国家“211工程”重点建设高校和“双一流”建设高校。',
    organizingtext2: ' 学校具有悠久的办学历史、厚重的文化积淀，源起1902年创建的三江师范学堂，历经国立中央大学、南京大学等发展时期;1958年南京工学院食品工业系整建制东迁无锡独立建校，成立无 锡轻工业学院;1962年无锡纺织工学院并入无锡轻工业学院;1995年更名为无锡轻工大学;2001年无锡轻工大学、江南学院、无锡教育学院合并组建江南大学;2003年东华大学无锡校区并入江 南大学。',
    organizingtext3: '建有食品科学与技术国家重点实验室、粮食发酵与食品生物制造国家工程研究中心、国家功能食品工程技术研究中心等国家级科研平台8个。学校坚持师生为重、服务为先，倾力打造曲水流 觞的现代化生态校园，为学生提供设施先进、功能齐全、优质舒适的成长环境。学校现启用蠡湖校区、东氿校区，总占地面积3786亩，总建筑面积119.87万平方米。',
    organizingtext4: '江南开学府，万顷湖波扬;屏障九龙好，山高水又长。”未来的办学实践中，我们将继续秉承“质量立校、人才强校、服务兴校、机制活校、文化铸校”的发展方略，努力推进“世界知名、中国一流、江南风格的研究型大学”建设，为实现高等教育强国梦和中华民族伟大复兴作出新的更大的贡献!',
    organizingsmalltitle2: '排名',
    organizingtext5: '学校的综合实力和办学影响不断提升。在教育部组织的最新一轮全国一级学科评估中，取得优异成绩;在2022年“软科世界一流学科排名”中，学校15个学科入选，食品科学与工程学科连续 四年蝉联世界第一;在全球基本科学指标数据库(ESI)上，学校农业科学、工程学、化学、生物学与生物化学材料科学、临床医学、计算机科学、药理学与毒理学、环境与生态学、微生物学10 个学科进入全球前 1%，其中农业科学跻身前0.12‰;学校位居ESI综合排行中国大陆第56名;在中国管理科学研究院编制的《2023中国大学评价》中，位居全国第49名。学校是全国教育系统先 进集体、江苏省文明单位、江苏省平安校园。',
    organizingaddresss: '地址',
    organizingaddressstext: '江苏省无锡市蠡湖大道1800号',
    organizingdetails: '详情请见:',
    organizingtext10: "邮编",
    organizingtext11: "214122",
    organizingtext12: "https://www.jiangnan.edu.cn/xxgk/xxjj.htm",
    //committee
    committeebigtitle: 'IDS 2024 委员会',
    committeeOrganizing: '组委会',
    committeeScientific: '科学委员会(IDS国际顾问团)',
    committeeheaderImg: 'http://music.chinaman.cn/mybigdatas/ids/static/commit2.png',
    committeepeopleList: [{
        name: "张慜",
        text: "江南大学，中国无锡 (IDS 2024主席)",
    },
    {
        name: "毕金峰",
        text: "中国农业科学院农产品加工研究所，中国北京",
    },
    {
        name: "陈晓东",
        text: "苏州大学，中国苏州",
    },
    {
        name: "段续",
        text: "河南科技大学，中国洛阳",
    },
    {
        name: "金敬红",
        text: "南京野生植物综合利用研究所，中国南京",
    },
    {
        name: "李大婧",
        text: "江苏省农业科学院农产品加工研究所，中国南京",
    },
    {
        name: "李所彬",
        text: "江苏博莱客冷冻科技发展有限公司，中国常州",
    },
    {
        name: "李占勇",
        text: "天津科技大学，中国天津",
    },
    {
        name: "王绍金",
        text: "西北农林科技大学，中国杨凌",
    },
    {
        name: "吴中华",
        text: "天津科技大学，中国天津",
    },
    {
        name: "肖红伟",
        text: "中国农业大学，中国北京",
    },
    {
        name: "郁东兴",
        text: "尚好科技有限公司，中国青岛",
    },
    {
        name: "查国才",
        text: "常州一步干燥设备有限公司，中国常州",
    },
    {
        name: "周存山",
        text: "江苏大学，中国镇江",
    },
        // {
        //     name: "王维",
        //     text: "大连理工大学，中国大连",
        // },

    ],
    committeetableData: [{
        date: "1",
        name: "Mujumdar A.S. (加拿大)",
        address: "Devahastin S. (泰国)",
    },
    {
        date: "2",
        name: "Abdelghani, B. (阿尔及利亚)",
        address: "Abdenouri, N. (摩洛哥)",
    },
    {
        date: "3",
        name: "Akinola A. (尼日利亚)",
        address: "Alves-Filho O. (挪威)",
    },
    {
        date: "4",
        name: "Andrieu J. (法国)",
        address: "Barresi A. (意大利)",
    },

    {
        date: "5",
        name: "Bruttini R. (意大利)",
        address: "Bhandari B. (澳大利亚)",
    },
    {
        date: "6",
        name: "Chen G. (中国香港)",
        address: "Chen X. D. (中国)",
    },
    {
        date: "7",
        name: "Farkas I. (匈牙利)",
        address: "Emam-Djomeh Z. (伊朗)",
    },

    {
        date: "8",
        name: "Itaya Y. (日本)",
        address: "Fortes M. (巴西)",
    },
    {
        date: "9",
        name: "Kemp I. (英国)",
        address: "Kechaou N. (突尼斯)",
    },
    {
        date: "10",
        name: "Krokida M. (希腊)",
        address: "Kowalski S. (波兰)",
    },

    {
        date: "11",
        name: "Langrish T. (澳大利亚)",
        address: "Kudra T. (加拿大)",
    },
    {
        date: "12",
        name: "Leonard A. (比利时)",
        address: "Law C.L. (马来西亚)",
    },
    {
        date: "13",
        name: "Miao S. (爱尔兰)",
        address: "Levy A. (以色列)",
    },

    {
        date: "14",
        name: "Opara L. (南非)",
        address: "Mulet A. (西班牙)",
    },
    {
        date: "15",
        name: "Pang S. (新西兰)",
        address: "Pakowski Z. (波兰)",
    },
    {
        date: "16",
        name: "Perré P. (法国)",
        address: "Peczalski R. (法国)",
    },
    {
        date: "17",
        name: "Rodriguez-Ramirez (墨西哥)",
        address: "Raghavan V. (加拿)",
    },
    {
        date: "18",
        name: "Rosello C. (西班牙)",
        address: "Renstrom R. (瑞典)",
    },

    {
        date: "19",
        name: "Prachayawarakorn S. (泰国) ",
        address: "Sarkar Md. S.H. (孟加拉国)",
    },
    {
        date: "20",
        name: "Sihem, B. (突尼斯)",
        address: "Schutyser M. (荷兰)",
    },

    {
        date: "21",
        name: "Thorat B. (印度)",
        address: "Taranto O. (巴西)",
    },
    {
        date: "22",
        name: "Tsotsas E. (德国)",
        address: "Timofeev O. (芬兰)",
    },
    {
        date: "23",
        name: "Zbicinski I. (波兰)",
        address: "Yagoobi J. (美国)",
    },
    {
        date: "24",
        name: "Zhou W. (新加坡)",
        address: "Zhang, M. (中国)",
    },
    ],

    //session
    sessionbigtitle: '主题报告',
    sessiontitle: '已确认的主题报告嘉宾:',
    sessionText18: [{
        num: "002",
        title: "Arun S. Mujumdar 教授",
        text: "麦吉尔大学",
        tip: "加拿大",
    },
    {
        num: "001",
        title: "Alex Martynenko 教授",
        text: "达尔豪斯大学",
        tip: "加拿大",
    },
    {
        num: "018",
        title: "Azharul Karim 教授",
        text: "昆士兰科技大学",
        tip: "澳大利亚",
    },
    {
        num: "007",
        title: "Benu Adhikari 教授",
        text: "皇家墨尔本理工大学",
        tip: "澳大利亚",
    },
    {
        num: "003",
        title: "Bhesh Bhandari 教授",
        text: "昆士兰大学",
        tip: "澳大利亚",
    },
    {
        num: "017",
        title: "Chinnaswamy Anandharamakrishna 博士",
        text: "CSIR-NIIST",
        tip: "印度",
    },
    {
        num: "006",
        title: "Chung Lim Law 教授",
        text: "马来西亚诺丁汉大学",
        tip: "马来西亚",
    },
    {
        num: "012",
        title: "Duu-Jong Lee 教授",
        text: "香港城市大学",
        tip: "中国",
    },
    {
        num: "009",
        title: "Evangelos Tsotsas 教授",
        text: "马格德堡大学",
        tip: "德国",
    },
    {
        num: "022",
        title: "Gennadiy Semenov 教授",
        text: "俄罗斯生物技术大学",
        tip: "俄罗斯",
    },
    {
        num: "011",
        title: "Hongwei Xiao 教授",
        text: "中国农业大学",
        tip: "中国",
    },
    {
        num: "013",
        title: "Ireneusz Zbiciński 教授",
        text: "罗兹理工大学",
        tip: "波兰",
    },
    {
        num: "015",
        title: "Itaya Yoshinori 教授",
        text: "岐阜大学",
        tip: "日本",
    },
    {
        num: "021",
        title: "Jamal Yagoobi 教授",
        text: "伍斯特理工学院",
        tip: "美国",
    },
    {
        num: "014",
        title: "Patrick Perre 教授",
        text: "巴黎萨克雷大学",
        tip: "法国",
    },
    {
        num: "016",
        title: "Peng Xu 教授",
        text: "中国计量大学",
        tip: "中国",
    },
    {
        num: "004",
        title: "Sakamon Devahastin 教授",
        text: "国王科技大学",
        tip: "泰国",
    },
    {
        num: "023",
        title: "Shaojin Wang 教授",
        text: "西北农林科技大学",
        tip: "中国",
    },
    {
        num: "024",
        title: "Sheyla Ramsay 博士",
        text: "百事公司",
        tip: "美国",
    },
    {
        num: "008",
        title: "Shusheng Pang 教授",
        text: "坎特伯雷大学",
        tip: "新西兰",
    },
    {
        num: "010",
        title: "Song Miao 教授",
        text: "Teagasc国家食品研究中心",
        tip: "爱尔兰",
    },
    {
        num: "019",
        title: "Vijaya Raghavan 教授",
        text: "麦吉尔大学",
        tip: "加拿大",
    },
    {
        num: "005",
        title: "Xiao Dong Chen 教授",
        text: "苏州大学",
        tip: "中国",
    },
    {
        num: "020",
        title: "Xu Duan 教授",
        text: "河南科技大学",
        tip: "中国",
    }, {
        num: '025',
        title: "Zhongli Pan 教授",
        text: "加利福尼亚大学戴维斯分校",
        tip: "美国"
    }
    ],

    //program
    programbigtitle: '议程',
    programbigtext: 'IDS 2024 大会议程正在建设中。',

    //submissions
    submissionsbigtitle: '提交稿件',
    submissionstitle1: '报告主题领域',
    submissionstitle2: '作者说明',
    submissionstitle3: '重要日期',
    submissionstitle4: '投稿方式',
    submissdataList: [
        "干燥机理、建模和模拟",
        "物理特性和产品质量",
        "工业流程和设备",
        "测量和过程控制",
        "能源和环境问题",
        "渗透脱水和干燥",
        "气体和液体的干燥",
        "粉末固体的干燥",
        "生物质能源应用中的干燥",
        "食品和农业材料的干燥",
        "生物和制药材料的干燥",
        "化学品和聚合物的干燥",
        "木材、纸浆/纸张、林产品的干燥",
        "新型干燥技术及研发",
    ],

    submissionstext21: '1. 投稿英文摘要字数不超过150字。',
    submissionstext22: '2. 提交的全文稿件全文最少5页，最多8页。',
    submissionstext23: '3. 作品必须是原创的、未发表过、没有在任何其他会议或期刊上进行过评审。所 有投稿将由科学委员会根据其原创性、重要性、方法合理性和阐述清晰度进行同 行评审。',
    submissionstext30: '<b class="text-red">2024 年 2 月 15 日:</b> 摘要提交截止 <br />< b class= "text-red" > 2024 年 3 月 31 日: 摘要录用通知 < br /><b class="text-red">2024 年 4 月 30 日:</b> 稿件提交截止 < br /> <b class="text-red">2024 年 6 月 15 日:</b> 稿件录用通知',

    submissionstext31a: '2024 年 3 月 15 日:',
    submissionstext32a: '2024 年 3 月 31 日:',
    submissionstext33a: '2024 年 4 月 30 日:',
    submissionstext34a: '2024 年 6 月 15 日:',

    submissionstext31b: '摘要提交截止',
    submissionstext32b: '摘要录用通知',
    submissionstext33b: '稿件提交截止',
    submissionstext34b: '稿件录用通知',

    submissionstext41: '做“演讲+海报”或“只出海报”，则应按照以下摘要模板准备:',
    submissionstext42: '“全文稿件”应按照以下模板准备:',
    submissionstext43: '在线提交链接',
    submissionstext44: '网上投稿系统',


    //reg
    regbigtitle: '注册',
    regtitle1: '注册和付款',
    regtitle2: '退款政策:',

    regtext11: '1. 请填写信息并完成付款',
    regtext11a: '在线注册和付款信息',
    regtext12: '2. 请将付款订单 ID 和“付款email地址”通过电子邮件发送给',
    regtext12a: '并等待大会秘书处的确认。',
    regCategory: '类别',
    regtableData: [{
        one: "代表",
        two: "450 美元",
        three: "500 美元",
    },
    {
        one: "学生",
        two: "220 美元",
        three: "250 美元",
    },
    {
        one: "陪同人员",
        two: "150 美元",
        three: "150 美元",
    },
    ],

    regpayabout1: '2024年7月1前"早鸟价"报名 【含宴会及文化活动费】 ',
    regpayabout2: '2024年7月1后"正常全价"报名 【不含宴会&文化活动费】',


    regtext21a: '江南大学银行账户1(美元汇款):',
    regtext22a: '收款人全称: 江南大学',
    regtext23a: '收款银行: 中国银行无锡分行营业部',
    regtext24a: '银行账号: 474158228044',
    regtext25a: 'SWIFT CODE: BKCHCNBJ95C',
    regtext26a: '* 宴会和文化活动费: 50美元。',

    regtext21b: '江南大学银行账户2(人民币汇款)',
    regtext22b: '账户名称:江南大学(江南大学)',
    regtext23b: '开户行:工商银行无锡江南大学支行',
    regtext24b: '银行账号:1103030709100000136',

    regtext31: '2024 年9月1日之前取消的注册将退还80%的费用。2024年9月1日之后取消的注册将不予退款。',
    regtext32: '取消和退款申请必须通过电子邮件正式提出。缺席者将不予退款。组委会对无法控制的问题概不负责，如天气状况、校园状况、旅行困难、签证问题等。',
    regtext33: '* 组委会保留因不可抗力而更改会议日期和地点的权利。',
    regtext34: '* 因不可抗力事件造成的损失不承担责任，退款政策也不适用。',

    //awards
    awardstitle: 'IDS 2024 奖项',
    awardstitle1: '1. Arun S Mujumdar 奖章',
    awardstitle2: '2. IDS主席奖',
    awardstitle3: '3. 杰出干燥研究奖',
    awardstitle4: '4. 优秀干燥研究奖',
    awardstitle5: '5. 青年干燥科学家奖',
    awardstitle6: '6. 口头报告奖',
    awardstitle7: '7. 海报展示奖',

    //sponsors
    sponsorsbigtitle: '赞助商',
    sponsorstext: '此页面正在建设中。',

    //visa
    visabigtitle: '签证',
    visabigtitle1: '签证信息:',
    visatext1: '签证邀请函可根据要求提供。为了使请求得到尊重，您必须是已被录用摘要的作者或合著者。 请下载此',
    visatext2: '邀请函模板，',
    visatext3: '填写您的信息并在“我的会议信息管理”中进行',
    visatext4: '上传。',
    visatext5: '它在“我的会议仪表板”中。',
    visatext6: '签字盖章后会通过电子邮件发给您。',
    visatext7: '* 有关邀请函的重要信息（请阅读）：',
    visatext8: '请注意，IDS2024大会和大会组委会除了提供由IDS2024大会和大会委员会理事会签发的邀请函通知外，无权协助办理签证手续。如果您的申请被拒，IDS2024大会和大会组委会不能改变外交部的决定，IDS2024大会和大会组委会也不会代表申请人与外交部或大使馆进行讨论或通信。',
    visatext9: '使馆处理 VISA 申请需要一定时间，请尽早报名以确保您有足够的时间。',


    //travel
    travelbigtitle: '会场',
    traveltext1: 'IDS 2024将在无锡君来世尊酒店举行。',
    traveltext2: '无锡君来世尊酒店地址 :',
    traveltext3: '江苏省无锡市滨湖区太湖新城和风路111号',
    traveltext4: '酒店网站:',
    travelText5: 'https://j.map.baidu.com/7c/mW2K',
    travelText6: "zh",

    //traveltwo
    traveltwobigtitle: '旅行',
    traveltwotext: '此页面正在建设中。',

    //hotel
    hotelbigtitle: '酒店',
    hoteltext: '此页面正在建设中。',


    //submissionUpload
    submissionUploadtitle: '会议信息',
    submissionUploadtext1: '第23届国际干燥研讨会(IDS 2024)',
    submissionUploadtext2: '会议日期:',
    submissionUploadtext3: '2024年11月22-25日',
    submissionUploadtext4: '会场',
    submissionUploadtext5: '无锡君来世尊酒店，中国无锡',

    submissionUploadmessageTitle: "请输入标题",
    submissionUploadmessageAbstract: "请输入摘要",
    submissionUploadmessagekeyword: "请输入关键字",
    submissionUploadmessagefile: "请选择上传文件",
    submissionUploadmessageauthor: "请输入作者",

    submissionUploadmessageauthor1: "请输入作者",
    submissionUploadmessageauthor1Firstname: "的名字(英文)",
    submissionUploadmessageauthor1Lastname: "的中间名:",
    submissionUploadmessageauthor1Position: "的职位",
    submissionUploadmessageauthor1Affiliation: "的机构(英文)",
    submissionUploadmessageauthor1email: "的电子邮箱",


    submissionUploadtitle: '论文信息',

    submissionUploadtext21: '作者信息',
    submissionUploadtext22: '电子邮件地址将仅用于与作者沟通，“通联系人”将收到来自系统的邮件。关于投稿，应至少标记一位通联系人 。',
    submissionUploadAuthor: '作者',
    submissionUploadAuthortext: '(请至少填写一位作者信息)',
    submissionUploadtext23: '单击此处添加更多作者',

    submissionUploadmoreauthors: '单击此处添加更多作者',
    submissionUploadtext24: '删除',
    submissionUploadtext25: '提交成功!',
    submissionUploadtext26: "文件不能超过200M",

    submissionUploadtext30: '名字(英文):*',
    submissionUploadtext31: '中间名:',
    submissionUploadtext32: '姓氏(英文):*',
    submissionUploadtext33: '职位:',
    submissionUploadtext34: '机构(英文):*',
    submissionUploadtext35: '电子邮件:*',
    submissionUploadtext36: '通联系人:',
    submissionUploadtext37: '口头报告作者:',
    submissionUploadtext38: '职位',
    submissionUploadtext39: '',
    submissionUploadtext40: '',

    submissionUploadSubmissionType: '投稿类型:*',
    submissionUploadAbstract: '摘要 (口头报告和海报)',
    submissionUploadPosterOnly: '摘要 (只海报)',
    submissionUploadFullpaper: '现在“全文稿件”提交尚未开放。当您在2024年3月31日收到摘要录用通知时，您可以选择开始提交全文。',
    submissionUploadtitleandAbstract: '标题和摘要',
    submissionUploadTitle: '标题:',
    submissionUploadTitleAbstract: '摘要:',
    submissionUploadAbstractabout: '标题和摘要应以纯文本形式输入，不应包含HTML元素。',
    submissionUploadKeywords: '关键词:',
    submissionUploadKeywordsabout: '至少指定三个关键词，以逗号分隔。',
    submissionUploadselect: '选择文件:',
    submissionUploadabouts: '如果您已填写表格，请点击下方“提交” 按钮。上传可能需要一段时间，请不要点击按钮两次。',

    submissionUploadSubmission: '提交',
    submissionUploadPeopleList: [
        [{
            text: "名字(英文):*",
            value: "",
            radio: "a",
        },
        {
            text: "中间名:",
            value: "",
            radio: "a",
        },
        {
            text: "姓氏(英文):*",
            value: "",
            radio: "a",
        },
        {
            text: "职位:",
            value: "",
            radio: "c",
            list: [{
                text: "Position",
            },
            {
                text: "Prof.",
            },
            {
                text: "Associate Prof.",
            },
            {
                text: "Assiatant Prof.",
            },
            {
                text: "Dr.",
            },
            {
                text: "Master",
            },
            {
                text: "Seniot Lecturer",
            },
            {
                text: "Lecturer",
            },
            {
                text: "Ph.D student",
            },
            {
                text: "Master student",
            },
            {
                text: "Undergraduate student",
            },
            {
                text: "Others",
            },
            ],
        },
        {
            text: "机构(英文):*",
            value: "",
            radio: "a",
        },
        {
            text: "电子邮件:*",
            value: "",
            radio: "a",
        },
        {
            text: "通联系人:",
            value: "1",
            radio: "b",
        },
        {
            text: "口头报告作者:",
            value: "1",
            radio: "d",
        },
        ],
    ],
    submissionUploadItem: [{
        text: "名字(英文):*",
        value: "",
        radio: "a",
    },
    {
        text: "中间名:",
        value: "",
        radio: "a",
    },
    {
        text: "姓氏(英文):*",
        value: "",
        radio: "a",
    },
    {
        text: "职位:*",
        value: "",
        radio: "c",
        list: [{
            text: "Position",
        },
        {
            text: "Prof.",
        },
        {
            text: "Associate Prof.",
        },
        {
            text: "Assiatant Prof.",
        },
        {
            text: "Dr.",
        },
        {
            text: "Master",
        },
        {
            text: "Seniot Lecturer",
        },
        {
            text: "Lecturer",
        },
        {
            text: "Ph.D student",
        },
        {
            text: "Master student",
        },
        {
            text: "Undergraduate student",
        },
        {
            text: "Others",
        },
        ],
    },
    {
        text: "机构(英文):*",
        value: "",
        radio: "a",
    },
    {
        text: "电子邮件:*",
        value: "",
        radio: "a",
    },
    {
        text: "通联系人:",
        value: "1",
        radio: "b",
    },
    {
        text: "口头报告作者:",
        value: "1",
        radio: "d",
    },
    ],


    //loginThen
    loginThenbigtitle: '签证',
    loginThentext1: '签证邀请函可根据要求提供。为了使请求得到尊重，您必须是已被录用摘要的作者或合著者。 请下载此',

    //loginThen
    loginThenbigtitle: '我的会议信息管理',
    loginThentitle1: '在线提交系统',
    loginThentitle12: '(摘要/论文全文)',
    loginThentitle2: '注册',
    loginThentitle3: '付费',
    loginThentitle4: '邀请函',
    loginThentextabout: '演讲者需要上传一篇“摘要/全文”',
    loginThenUpload: '上传',

    loginThenPaperID: '文章 ID',
    loginThentitle: '题目',
    loginThensubmissionType: '提交类型',
    loginThenkeywords: '关键词',
    loginThensuEdit: '编辑',
    loginThenDelete: '删除',

    //simpleReg
    simpleRegTitle: '头衔',
    simpleRegFirstname: '名字(英文)',
    simpleRegLastname: '姓氏(英文)',
    simplePassword: '密码',
    simplePasswordpic: '密码长度需要为6-15',
    simpleRetypePassword: '重新键入密码',
    simpleCode: '验证码*（区分大小写）',
    simpleSignin: '注册',
    simpleSignintip1: '已注册？',
    simpleSignintip2: '到登录页',


    simpleSignmsgemail: '请输入您的电子邮件地址',
    simpleSignmsgFirstname: '请输入您的名字(英文)',
    simpleSignmsgLastname: '请输入您的姓氏(英文)',
    simpleSignmsgPassword: '请输入您的密码',

    simpleSignmsgRetypePassword: '请重新输入您的密码',
    simpleSignmsgPasswordinconsistency: '两次密码不一致',

    simpleSignmsgpasswordpic: '密码长度需要为6-15',
    simpleSignmsgCode: '请输入验证码',
    simpleSignmsgCodeinconsistency: '验证代码不一致',
    simpleSignmsgRegistrationsuccessful: '注册成功',

    newsDetailText1: "摘要提交截止日期延长至 3 月 15 日",
    newsDetailText2: "[通知] 论文摘要提交截止日期延长至 3 月 15 日。",
    newsDetailText3: "我们希望能让更多的人有机会积极参与大会，分享他们的最新研究成果，从而使大会的内容更加丰富和有趣.",
    newsDetailText4: "期待您的论文摘要，期待您参与 IDS2024！",
    newsDetailText5: '距离摘要提交截止仅剩1周',
    newsDetailText6: "——2024年3月8日更新",
    newsDetailText7: 'zh',
    newsDetailText8: '距离全文提交截止仅剩1周',
    newsDetailText9: "——2024年4月23日更新"
}


// WEBPACK FOOTER //
// ./src/utils/zh.js